import BannerHeader from "../../Components/BannerHeader/BannerHeader";
import PrimaryNav from "../Header/PrimaryNav/PrimaryNav";
import classes from "./Services.module.css";
import CustomizationSteps from "./CustomizationSteps/CustomizationSteps";
import WhyUs from "./WhyUs/WhyUs";
import BookCustomization from "../Body/BookCustomization/BookCustomization";
import Gallery from "../Body/Gallery/Gallery";
import CustomerReview from "../Body/CustomerReview/CutomerReview";
import FAQ from "./FAQ/FAQ";
import { ContactUs } from "./Components/ContactUs/ContactUs";
import Footer from "../Footer/Footer";

import { useEffect } from "react";
import ServiceVideo from "./Components/ServiceVideo/ServiceVideo";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllVideos } from "../../Store/actions/ServiceVideoAction";
import useScrollToTop from "../../Hooks/useScrollToTop";
import { getAllFaq } from "../../Store/actions/FaqAction";
import SEO from "../../Components/SEO";

const banner = "/Assets/Images/ServicePages/BookCustomization.png";
const Services = () => {
  const crumbs = [
    { title: "Home", path: "/" },
    { title: "Book Customization", path: "/services" },
  ];

  const video = useSelector((state) => state.serviceVideo.videos?.servicesVideo);
  const allFaq = useSelector((state) => state.Faq.questions);

  const dispatch = useDispatch();

  useEffect(() => {
    fetchAllVideos(dispatch);
  }, []);

  useEffect(() => {
    getAllFaq("category", "Customization", "", dispatch);
  }, []);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollRef = useScrollToTop();

  return (
    <>
      <SEO
        keywords="Customized books"
        title="Buy Handmade Customized & Personalized Books for Adults"
        description="Explore Customized & Personalized Books at Rare Biblio. Handmade with love—create your story, your way. Preserve memories or gift one. Order yours today!"
        canonicalUrl="https://rarebiblio.com/customized-personalized-books"
        structuredData={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Service",
              "name": "Customized and Personalized Books",
              "description": "Discover high-quality customized and personalized books at Rare Biblio. Handmade, leather-bound, and tailored to your unique preferences.",
              "provider": {
                "@type": "Organization",
                "name": "Rare Biblio",
                "url": "https://www.rarebiblio.com/",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://www.rarebiblio.com/Assets/Icons/logo.jpg"
                },
                "sameAs": [
                  "https://www.facebook.com/rarebiblio/",
                  "https://www.instagram.com/Rarebiblio/",
                  "https://www.linkedin.com/company/Rarebiblio",
                  "https://in.pinterest.com/rare_biblio/",
                  "https://x.com/Rarebiblio"
                ]
              },
              "areaServed": {
                "@type": "Place",
                "name": "Worldwide"
              },
              "serviceType": "Customized Books, Personalized Leather-Bound Books",
              "url": "https://www.rarebiblio.com/customized-personalized-books"
            },
            {
              "@type": "FAQPage",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "Can I add a special message or name to the book?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes! Our customization feature allows you to add a special message, name, or any text you'd like to engrave on the leather cover. Whether it’s for a gift or personal use, this makes your book even more meaningful and unique."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I see a preview of my customized book before ordering?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes! We offer a 3D preview of the book you are designing. Once you’ve selected your customization options, you can view a realistic 3D model of your personalized leather book. This allows you to make sure everything looks perfect before placing your order."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I get help designing my book?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolutely! Our expert designers will assist you throughout the design process. We’ll provide you with a custom mock-up of your book design so you can visualize how it will look before finalizing everything. Our goal is to make sure you’re completely satisfied with the design!"
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do you offer multiple options for leather quality?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we offer a range of leather options, including both high-quality, economical leather and luxury, high-grade leather. This gives you the flexibility to choose the perfect material that fits both your budget and your style preferences."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I create a special design for myself?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, absolutely! We encourage you to bring your unique ideas to life. Our team will work closely with you to design something special that reflects your vision. Whether it's custom artwork, text, or other personalized elements, we’ll ensure your design is exactly what you want."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How long will a customized book take to deliver?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Our leather book-binding process is fully handcrafted, including any customizations; therefore, it takes 10-14 days to craft your customized book to perfection. However, if you need it sooner, feel free to reach out to us, and we can discuss faster delivery options."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do you offer marble endpapers?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Our marble endpapers are carefully selected to complement the design of your book, enhancing its overall appeal. We ensure that the color and pattern of the marble endpapers perfectly match the book’s aesthetic for a stunning finish."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do you offer spray edge gilding or foil pressed gilding?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We primarily offer foil pressed gilding for a beautiful and durable finish. However, if you prefer spray edge gilding, we can certainly accommodate that request as well. Just let us know, and we’ll make it happen!"
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do you also offer raised bands on the spine?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, our standard books come with 4 raised bands on the spine. If you have a specific design in mind, we can customize it further to meet your preferences."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I emboss a logo on the spine?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, we can emboss your logo on the spine or the front cover, depending on your preference. We'll work with you to ensure the placement and design are exactly how you envision it."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do you offer any budget-friendly options?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We specialize in crafting premium leather-bound editions, but we understand the importance of staying within budget. Please reach out to us through our 'Contact Us' form, and we’ll be happy to guide you on the best options that fit your budget while maintaining the quality you expect."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What’s the difference between the Super Deluxe and Deluxe editions?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The Deluxe edition is a more budget-friendly option, featuring half-leather binding for a stylish yet affordable look. The Super Deluxe edition, on the other hand, offers full leather binding, providing a luxurious and premium finish for a more elegant feel."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What is the difference between the customized and personalized options for the book?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The customized option allows you to fully design your book’s layout, materials, and features, from the cover to the binding, giving you complete control over the final product. The personalized option, on the other hand, focuses more on adding personal touches such as your name, logo, or a special message, while keeping the overall design structure standard."
                  }
                }
              ]
            }
          ]
        }}
      />
    <div className={classes.mainContainer} ref={scrollRef}>
      <PrimaryNav />
      <BannerHeader
        title={`Customized and Personalized Books Of Your Style`}
        crumbs={crumbs}
        desc={
          "Craft Your Perfect Book: Customizable Front Covers, Spines, Endpapers, and Gilding"
        }
        bgImage={banner}
      />

      <div className={classes.customisedPersonalised}>
        {video && <ServiceVideo
          title={"Customized and Personalized Books Of Your Style"}
          desc={
            "Rare Biblio understands that books are no less than any emotion, they are not just a text printed on paper rather they speak for you, and they represent you and your individuality. That’s why we have come up with this amazing offering for you where you can deep dive into book customization and design and frame your books and stories in a way you love and create something unique for yourself and your loved ones"
          }
          videoSrc={video}
        />}
        {/* <CustomisedBooks /> */}
      <ContactUs className={classes.contactUs} category={"bookCustomization"} />
      </div>
      <div className={classes.customizationSteps}>
        <CustomizationSteps />
      </div>
      <div className={classes.whyUs}>
        <WhyUs />
      </div>
      <div className={classes.bookCustomization}>
        <BookCustomization />
      </div>
      <div className={classes.gallery}>
        <Gallery />
      </div>
      <div className={classes.customerReview}>
        <CustomerReview />
      </div>

      <div className={classes.faqSection}>
        <FAQ data={allFaq}/>
      </div>

      <div className={classes.footerSection}>
        <Footer />
      </div>
    </div>
    </>
  );
};

export default Services;
